import { render } from "./FarmerRewardDisplay.vue?vue&type=template&id=571e47f4&ts=true"
import script from "./FarmerRewardDisplay.vue?vue&type=script&lang=ts"
export * from "./FarmerRewardDisplay.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\Domingos\\Documents\\GitHub\\staking-fe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__